/**
* ---------------------------------------------
* Customizations to Wishlist (swym)
* ---------------------------------------------
*/

/**
 * Hides wishlist widget if empty
 */
async function customWishlist () {
  const swymAnchorEl = await waitForElement('#swym-anchor', document)

  swymAnchorEl.classList.add('hidden')

  const itemCountEl = await waitForElement('[data-count]', swymAnchorEl)
  const itemCount = parseInt(itemCountEl.dataset.count, 10)

  if (itemCount > 0) {
    swymAnchorEl.classList.remove('hidden')
  }

  itemCountEl.addEventListener('DOMSubtreeModified', () => {
    swymAnchorEl.classList.toggle('hidden', (parseInt(itemCountEl.dataset.count, 10) === 0))
  })
}

/**
 * Waits for element to appear
 * @param {string} selector : passed to querySelector
 * @param {HTMLElement} parent : element to query from
 * @returns element once found
 */
function waitForElement(selector, parent) {
  return new Promise(resolve => {
    if (parent.querySelector(selector)) {
      return resolve(parent.querySelector(selector))
    }

    const observer = new MutationObserver(mutations => {
      if (parent.querySelector(selector)) {
        resolve(parent.querySelector(selector))
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  customWishlist()
})
